import React, { useCallback, useMemo, useEffect, useState } from "react";
import axios from "axios";
import { apiUrl } from "../commons/inFormTypes";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Container, Col, Row, Button, Form, Image,Card } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import ImageBox from "./ImageBox";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import Loaders from "../components/Loaders";
import LoaderBtn from "../components/LoaderBtn";
import { NavLink, useNavigate } from 'react-router-dom'
import AllHeader from "../components/AllHeader";
import useCheckUser from "../custom-hooks/useCheckUser";
import Parent from "../container/Parent";

const obj = { image0: "", image1: "", image2: "", image3: "" };


function News(props) {
  const [reload, setReload] = useState(false)
  const [seenFile, setSeenFile] = useState([]);
  const [title, setTitle] = useState("");
  const [date, setDate] = useState(new Date());
  const [description, setDescription] = useState("");
  const [load, setLoad] = useState(false)
  const UserID = localStorage.getItem("UserId");
  const navigate = useNavigate();
  const allowedState = [];
  const [stateImages, setstateImages] = useState([]);
  const [images, setImages] = useState([]);
  const onDrop = useCallback((acceptedFiles) => {
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  const [files, setFiles] = useState([]);
  // clean up

    // Example usage of the custom hook
    useCheckUser(UserID); // Replace UserID with the actual user ID value

      useEffect(() => { 
        if (UserID !== null) {
        files.forEach((file) => URL.revokeObjectURL(file.preview));
        //show news
        const axios = require("axios");
        axios
          .post(apiUrl + "GetNews_Citizen", {
            Id: UserID,
            Uid: UserID,
          })
          .then((res) => {
            if (res.data.result === "true") {
              setSeenFile(res.data.data)
            } else {
              setLoad(true)
              toast.error(res.data.message, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
              });
            }
          });
        }
    }, [files,reload]);


  const handleSubmit = (e) => {
    e.preventDefault();
    if (title === "" || date === "" || description === "") {
      toast.error("لطفا اطلاعات را تکمیل کنید ", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return;
    }
    setLoad(true)
    var pic = images.length > 0 ? images[0].replace('data:image/png;base64,', '').replace('data:image/jpg;base64,', '').replace('data:image/jpeg;base64,', '') : '';
    const axios = require("axios");
    axios
      .post(apiUrl + "InsertNews", {
        Id: 0,
        Tittle: title,
        Pid: UserID,
        Pic: pic,
        Type: 2,
        Active: 0,
        Chekideh: "",
        Text: description,
        Tarikh: typeof date !== 'string' ? new Date(date).toLocaleDateString("fa-IR") : date,
        Uid: UserID,
      })
      .then((res) => {
        if (res.data.result === "true") {
          if(reload) {
            setReload(false)
          }else {
            setReload(true)
          }
          setImages([])
          setLoad(false)
          setTitle("")
          setDate("")
          setDescription("")
          toast.success(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        } else {
          setLoad(true)
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
  };

  const showImages = (e) => {
    if (e.files.length <= 4) {
      var fr = null;
      for (var i = 0; i < e.files.length; i++) {
        // if (e.files[i].size > 2000000) {
        //   toast('عکس نباید بیشتر از 2 مگابایت باشد', {
        //     position: toast.POSITION.TOP_CENTER,
        //     autoClose: 3000,
        //   });
        //   return;
        // }
        fr = new FileReader();
        fr.onload = (e) => setImages((prev) => [...prev, e.target.result]);
        if (obj.image0 == "") {
          obj.image0 = e.files[i].name;
        } else if (obj.image1 == "") {
          obj.image1 = e.files[i].name;
        } else if (obj.image2 == "") {
          obj.image2 = e.files[i].name;
        } else if (obj.image3 == "") {
          obj.image3 = e.files[i].name;
        }
        fr.readAsDataURL(e.files[i]);
      }
      allowedState.push(obj);
      setstateImages(allowedState);
    } else {
      // toast('امکان انتخاب بیشتر از ۴ عکس نمی باشد', {
      //   position: toast.POSITION.TOP_CENTER,
      //   autoClose: 3000,
      // });
    }
  };

  const deleteImage = (index) => {
    var newImages = images;
    newImages.splice(index, 1);
    setImages(() => [...newImages]);
    switch (index) {
      case 0:
        obj.image0 = obj.image1;
        obj.image1 = obj.image2;
        obj.image2 = obj.image3;
        obj.image3 = "";
        break;
      case 1:
        obj.image1 = obj.image2;
        obj.image2 = obj.image3;
        obj.image3 = "";
        break;
      case 2:
        obj.image2 = obj.image3;
        obj.image3 = "";
        break;
      case 3:
        obj.image3 = "";
        break;
    }
  };

  return (
    <div className="py-5">
      <AllHeader>
        <span>شهروند خبرنگار</span>
      </AllHeader>
      {/* <Container> */}
      <Parent>
        <Row className="justify-content-center">
          <Col md={8} className="rgc-title">
             <div >
            <p>
              لطفا در صورت مورد تایید بودن خبر، آن را با ما به اشتراک بگذارید
            </p>
            <Form>
              <Row className="justify-content-center">
                <Col md="6" className="mb-3">
                  <Form.Group>
                    <Form.Label>عنوان خبر:</Form.Label>
                    <Form.Control
                      className="rgc-font-number"
                      placeholder="عنوان خبر"
                      type="text"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </Col>

                <Col className="pr-1" md="6">
                  <Form.Group>
                    <Form.Label>تاریخ :</Form.Label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-right"
                      value={date}
                      onChange={setDate}
                    />
                  </Form.Group>
                </Col>

                <Col md="12">
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>شرح خبر:</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      className="rgc-font-number"
                      placeholder=" شرح خبر..."
                      type="text"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md="12" className="mb-3">
                  <div className="dropzone mt-3" id="form5Dropzone">
                    <div {...getRootProps()}>
                      <input
                        {...getInputProps()}
                        onChange={(e) => showImages(e.target)}
                        accept="image/gif, image/jpeg, image/png"
                      />
                      {isDragActive ? (
                        <button className="dz-button" type="button">
                          <i className="fas fa-plus-square"></i>
                          انتخاب تصاویر
                        </button>
                      ) : (
                        <button className="dz-button" type="button">
                          <i className="fas fa-plus-square"></i>
                          انتخاب تصاویر
                        </button>
                      )}
                    </div>
                  </div>
                </Col>


                <Col md="12" className="mb-3">

                  <div className="row justify-content-center">
                    <ImageBox
                      ali={1}
                      src={images[0]}
                      remove={() => deleteImage(0)}
                    />
                    {/* <ImageBox
                      ali={2}                    
                      src={images[1]}
                      remove={() => deleteImage(1)}
                    />
                    <ImageBox
                      ali={3}
                      src={images[2]}
                      remove={() => deleteImage(2)}
                    />
                    <ImageBox
                      ali={4}
                      src={images[3]}
                      remove={() => deleteImage(3)}
                    /> */}
                  </div>
                </Col>


                <Col xs="5" md="4" className="text-center">
                  <Button
                    className="btn-fill rgc-btn"
                    type="submit"
                    variant="primary"
                    onClick={handleSubmit}
                  >
                    <LoaderBtn loads={load} />
                    <span>ثبت</span>
                  </Button>
                </Col>
              </Row>
            </Form>
            </div>
          </Col>
        </Row>     
        <Row className="py-3">
          {seenFile.map((data, index) => {
            return (
              <Col xs={12} sm={6} lg={4} className="rgc-news-item" key={index}>
                <Card className="rgc-news">
                  <Row>
                    <Col xs={5} className="rgc-img-news">
                      <Image src={'data:image/png;base64,' + data.Pic} alt="" fluid />
                    </Col>
                    <Col xs={7} className="rgc-text-news">
                      <div className="d-flex flex-column">
                      <span>عنوان:{data.Tittle}</span>
                      <span>تاریخ خبر:{data.Tarikh}</span>
                      <span> وضعیت:{data.Active === 1 ? "فعال" : "غیرفعال"}</span>   
                      </div>

                    </Col>
                  </Row>
                </Card>
              </Col>
            )
          })
          }
        </Row>
      {/* </Container> */}
      </Parent>

      <div className="rgc-toast">
        <ToastContainer
          autoClose={3000}
        />
      </div>

    </div>
  );
}

export default News;
